<section>
    <div class=content>
        <div class="wrapper-1">
          <div class="wrapper-2">
            <h1>Thank you !</h1>
            <p>Thanks for submitting your enquiry to our Website.  </p>
            <p>You should receive a Email/Call soon to discusse further  </p>
            <a href="https://www.kidzee.com/" target="_blank">
            <button class="btn back_btn">
             Know More
            </button>
        </a>
          </div>
      </div>
      </div>
        </section>
        <div class="footer_contenr">
            <footer class="desktopResponsive">
                <div class="footerContent">
                    <div class="row py-5">
                        <div class="col-md-4">
                         <div class="logo_box d-flex">
                            <div class="kidzeeLogo">
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kidzee_footer_logo.png" width="90%" alt="">
                            </div>
                            <div class="zeeLogo">
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/zee_footer_logo.png" width="90%" alt="">
                            </div>
                         </div>
                        </div>
                        <div class="col-md-4 d-flex justify-content-center">
                            <div class="footer_content">
                         <p class="text-white">For Admissions Enquiry,</p>
                         <a href="tel:+1234567890"><p class="text-white">Call +91 93200 63100</p></a>
                        <p class="text-white">Monday to Friday - 10 a.m. to 6 p.m.</p>
                    </div>
                        </div>
                        <div class="col-md-4 d-flex justify-content-center align-items-center">
                            <div class="fb_insta_icon_content">
            
                                <a href="https://www.facebook.com/KidzeeIndia" target="_blank"> <i class="fa fa-facebook media_icon"></i></a>
                                <a href="https://www.instagram.com/kidzeeindia/" target="_blank">
                                   <i class="fa fa-instagram media_icon"></i>
                               </a>
                               <a href="https://www.instagram.com/kidzeeindia/" target="_blank">
                                <i class="fa fa-youtube-play media_icon"></i>
                            </a>
                               </div>
                        </div>
                    </div>
                </div>
                <div class="btn_header" id="footer_btn">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="text-white text-center footerTextEmailId">
                                Copyright © 2025 Zee Learn Ltd. | T&C | Privacy Policy | Disclaimer
                            </div>
                        </div>
                    </div>
                </div>
                <a href="#" class="scrollToTop" id="scroll_Top_btn">
                    <button class="btn scroll_btn"><i class="fa fa-chevron-up"></i></button></a>
            </footer>
            
            <footer class="mobileResponsive">
                <div class="footerContent">
                    <div class="row py-5">
                        <div class="col-md-4">
                         <div class="logo_box">
                            <div class="kidzeeLogo d-flex justify-content-center">
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kidzee_footer_logo.png" width="65%" alt="">
                            </div>
                            <div class="zeeLogo d-flex justify-content-center">
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/zee_footer_logo.png" width="65%" alt="">
                            </div>
                         </div>
                        </div>
                        <div class="col-md-4 d-flex justify-content-center mt-4">
                            <div class="footer_content">
                         <p class="text-white">For Admissions Enquiry,</p>
                         <a href="tel:+1234567890"><p class="text-white">Call +91 93200 63100</p></a>
                        <p class="text-white">Monday to Friday - 10 a.m. to 6 p.m.</p>
                    </div>
                        </div>
                        <div class="col-md-4 d-flex justify-content-center align-items-center">
                            <div class="fb_insta_icon_content">
            
                                <a href="https://www.facebook.com/KidzeeIndia" target="_blank"> <i class="fa fa-facebook media_icon"></i></a>
                                <a href="https://www.instagram.com/kidzeeindia/" target="_blank">
                                   <i class="fa fa-instagram media_icon"></i>
                               </a>
                               <a href="https://www.instagram.com/kidzeeindia/" target="_blank">
                                <i class="fa fa-youtube-play media_icon"></i>
                            </a>
                               </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="text-white text-center footerTextEmailId">
                                Copyright © Zee Learn Ltd. All rights reserved.
                            </div>
                        </div>
                    </div>
                </div>
            
                <a href="#" class="scrollToTop" id="scroll_Top_btn">
                    <button class="btn scroll_btn"><i class="fa fa-chevron-up"></i></button></a>
            </footer>
            
        </div>